import { useEffect, useState } from "react";

export type LayoutMode = "desktop" | "tablet" | "mobile";

function detectLayout(): LayoutMode {
  if (typeof window === "undefined") return "desktop";
  const w = window.innerWidth;
  if (w <= 640) return "mobile";
  const touch = window.matchMedia("(hover: none) and (pointer: coarse)").matches;
  // Touch-Tablet auch im Querformat (iPad Pro etc.)
  if (touch && w <= 1366) return "tablet";
  if (w <= 1100) return "tablet";
  return "desktop";
}

export function isCompactLayout(mode: LayoutMode): boolean {
  return mode === "tablet" || mode === "mobile";
}

/** Nur Handy: einklappbare Rails, Coach-Drawer unten. Tablet ≈ PC. */
export function isMobileHud(mode: LayoutMode): boolean {
  return mode === "mobile";
}

/** PC · Tablet (Touch, 3-Spalten) · Handy (Drawer). */
export function useLayoutMode(): LayoutMode {
  const [mode, setMode] = useState<LayoutMode>(() => detectLayout());

  useEffect(() => {
    const update = () => setMode(detectLayout());
    const m640 = window.matchMedia("(max-width: 640px)");
    const m1100 = window.matchMedia("(max-width: 1100px)");
    const touch = window.matchMedia("(hover: none) and (pointer: coarse)");
    m640.addEventListener("change", update);
    m1100.addEventListener("change", update);
    touch.addEventListener("change", update);
    window.addEventListener("orientationchange", update);
    window.addEventListener("resize", update);
    return () => {
      m640.removeEventListener("change", update);
      m1100.removeEventListener("change", update);
      touch.removeEventListener("change", update);
      window.removeEventListener("orientationchange", update);
      window.removeEventListener("resize", update);
    };
  }, []);

  return mode;
}
